// Returns the full hostname of a URL, preserving the `www.` prefix
// (unlike `extractHostname`, which strips it). Falls back to the raw
// input for malformed URLs.
export const getUrlHostname = (url: string): string => {
  try {
    return new URL(url).hostname
  } catch {
    return url
  }
}
